import {
  fetchCurrentUserData,
  fetchUser,
  fetchUsers,
  getItemFromCollection,
  getItemsFromCollection,
} from "directus/src/operations";

export async function fetchLoggedInUser() {
  try {
    const query = {
      fields: [
        "id",
        "first_name",
        "last_name",
        "role",
        "role.name",
        "role.policies",
        "role.policies.policy",
        "role.policies.policy.admin_access",
        "role.is_project_coordinator",
        "role.is_sales_coordinator",
        "role.is_account_manager",
        "role.is_job_coordinator",
        "role.is_milestone_coordinator",
        "role.is_department_head",
        "role.is_teamlead",
        "policies.policy.admin_access",
      ],
    };

    const response = await fetchCurrentUserData(query);

    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchEmployeeData() {
  try {
    const query = {
      filter: {
        user: {
          _eq: "$CURRENT_USER",
        },
      },
      fields: [
        "id",
        "secondary_job_title",
        "first_name",
        "last_name",
        "email",
        "avatar",
        "employee_id",
        "grade.name",
        "reports_to.id",
        "reports_to.first_name",
        "reports_to.last_name",
        "reports_to.avatar",
        "function.name",
        "consumption_factor",
        "discord_user_id",
        "github_username",
        "legal_entity.id",
        "phone_no",
        "emoji",
        "allocable",
        "job_title.name",
        "department.name",
        "department.id",
      ],
    };
    const response = await getItemsFromCollection("employees", query);

    return response[0];
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const fetchHasTeamMembers = async () => {
  try {
    const query = {
      filter: {
        reports_to: "$CURRENT_USER",
        user: {
          status: { _eq: "active" },
        }
      },
      aggregate: {
        countDistinct: ["id"],
      },
    };

    const data = await getItemsFromCollection("employees", query);

    const hasTeamMembers = data[0].countDistinct.id > 0;

    return hasTeamMembers; // Return 0 if no valid scores found
  } catch (err) {
    return err;
  }
};

export async function fetchIsCurrentUserTeamLead() {
  try {
    const query = {
      filter: {
        "count(reportees)": {
          _gt: 0,
        },

        reportees: {
          status: {
            _eq: "active",
          },
        },
      },
      aggregate: {
        countDistinct: "id",
      },
    };
    const response = await fetchCurrentUserData(query);
    return response?.countDistinct?.id > 0;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
